<template>
  <div>
    <Head />

    <nav class="breadcrumb_box" aria-label="breadcrumb">
      <ol class="breadcrumb container">
        <li class="breadcrumb-item"><router-link to="/">{{ $t('首頁') }}</router-link></li>
        <li class="breadcrumb-item active" aria-current="page">{{ $t('登入') }}</li>
      </ol>
    </nav>
    <div class="wrapper list order_list">
      <svg class="bg"></svg>
      <div class="container">
        <div class="title_box">
          <h1>{{ $t('申請單管理') }}</h1>
        </div>
        <ul class="btn_box">
          <li>
            <button class="item_btn" :class="Type == 0 ? 'active' : ''" @click="Type = 0">{{ $t('全部') }}</button>
          </li>
          <li>
            <button class="item_btn" :class="Type == 1 ? 'active' : ''" @click="Type = 1">{{ $t('教職宿舍') }}</button>
          </li>
          <li>
            <button class="item_btn" :class="Type == 2 ? 'active' : ''" @click="Type = 2">{{ $t('學人宿舍') }}</button>
          </li>
          <li>
            <button class="item_btn" :class="Type == 3 ? 'active' : ''" @click="Type = 3">{{ $t('停車位') }}</button>
          </li>
        </ul>
        <div class="list_box show">
          <div class="box" v-for="Order in Orders" :key="Order.OId">
            <div class="title">
              <h2>
                <span>{{ $t('教職宿舍') }}</span>
                <p>{{ $t('訂單編號') }}</p>
                <p>{{ Order.OrderId }}</p>
              </h2>
            </div>
            <div class="text_box">
              <div class="text">
                <div class="full">
                  <p>{{ $t('內容') }}</p>
                  <p>{{ Order.Title }}</p>
                </div>
                <div class="full">
                  <p>{{ $t('訂單時間') }}</p>
                  <p>{{ Order.Time }}</p>
                </div>
                <div class="full payment_box">
                  <p>{{ $t('繳款狀態') }}</p>
                  <p class="payment" v-if="Order.Status == 2">
                    <img src="img/progress_icon3.svg" alt="">
                    <span class="">{{ $t('已繳款') }}</span>
                  </p>
                  <!-- <button class="payment">
                    <img src="img/progress_icon4.svg" alt="">
                    <span class="fail">扣款失敗</span>
                  </button>
                  <p class="reason">7月扣繳失敗7月扣繳失敗7月扣繳失敗</p> -->
                  <p class="payment" v-if="Order.Status == 1">
                    <img src="img/progress_icon5.svg" alt="">
                    <span class="">{{ $t('未繳款') }}</span>
                  </p>
                </div>
                <div class="full" v-if="Order.Status == 1 && Order.CanPrint">
                  <p>{{ $t('繳費單') }}</p>
                  <p>
                    <button class="download_box" @click="downloadBill(Order.OrderId)">{{ $t('下載') }}</button>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="list_box show" v-if="Orders.length == 0">
          <div class="box">
            <div class="none_text">
              <p>{{ $t('查無資料...') }}</p>
            </div>
          </div>
        </div>
        <paginate :no-li-surround="false" :page-count="pageAll" :page-range="3" :margin-pages="1"
          :click-handler="loadList" :prev-text="'«'" :next-text="'»'" :prev-link-class="'page-link'"
          :next-link-class="'page-link'" :container-class="'pagination'" :page-class="'page-item'"
          :page-link-class="'page-link'" :active-class="'active'" :hide-prev-next="false" v-if="pageAll > 1">
        </paginate>
      </div>
    </div><!-- wrapper -->

    <Footer />
  </div>
</template>
<script>
import Head from "@/components/Head.vue";
import Footer from "@/components/Footer.vue";

import Vue from "vue";

import axios from "axios";
import VueAxios from "vue-axios";
Vue.use(VueAxios, axios);

import VueI18n from "vue-i18n";
Vue.use(VueI18n);

import Paginate from "vuejs-paginate";
Vue.component("paginate", Paginate);

const messages = {
  zh_tw: {
    "首頁": "首頁",
    "登入": "登入",
    "申請單管理": "申請單管理",
    "全部": "全部",
    "教職宿舍": "教職宿舍",
    "學人宿舍": "學人宿舍",
    "停車位": "停車位",
    "訂單編號": "訂單編號",
    "內容": "內容",
    "訂單時間": "訂單時間",
    "繳款狀態": "繳款狀態",
    "已繳款": "已繳款",
    "未繳款": "未繳款",
    "繳費單": "繳費單",
    "下載": "下載",
    "查無資料...": "查無資料...",
    "請先登入帳號": "請先登入帳號",
  },
  en: {
    "首頁": "Home Page",
    "登入": "Login",
    "申請單管理": "Application  Management",
    "全部": "All",
    "教職宿舍": "Faculty & Staff Dormitory",
    "學人宿舍": "Visiting Scholars Dormitory",
    "停車位": "Parking Space",
    "訂單編號": "Order Number",
    "內容": "Content",
    "訂單時間": "Order Date and Time",
    "繳款狀態": "Payment Status",
    "已繳款": "Paid",
    "未繳款": "Unpaid",
    "繳費單": "Payment invoice",
    "下載": "Download",
    "查無資料...": "No information available…",
    "請先登入帳號": "Please log in first",
  },
};

const i18n = new VueI18n({
  locale: "zh_tw",
  messages,
});

import AES from "@/utils/aes.js";
import Validate from "@/utils/validate.js";

export default {
  name: "Order",
  i18n,
  components: {
    Head,
    Footer,
  },
  data() {
    return {
      OrderData: {},
      Type: 0,
      Orders: [],
      pageAll: 0,
      perPage: 10,
      local: "zh_tw",
    };
  },
  watch: {
    Type(newValue, oldValue) {
      this.loadList(1);
    }
  },
  beforeCreate: function () {
    if (!$cookies.isKey("dormitory_login_token")) {
      Swal.fire({
        title: this.$t("請先登入帳號"),
        icon: "info",
        allowOutsideClick: false,
        heightAuto: false,
        willClose: () => {
          this.$router.push({
            name: "Home",
          });
        },
      });
      return;
    }
  },
  created: function () {
    Vue.axios
      .get(
        this.$store.state.src +
        this.$store.state.subDirectory +
        "/Html/Order",
        {
          params: { token: $cookies.get("dormitory_login_token") },
        }
      )
      .then((response) => {
        this.ProgressData = response.data;
        this.loadList(1);
      })
      .catch((error) => {
        console.log(error);
      });
  },
  mounted: function () {
    if ($cookies.isKey("dormitory_site_lang")) {
      i18n.locale = $cookies.get("dormitory_site_lang");
      this.local = $cookies.get("dormitory_site_lang");
    } else {
      i18n.locale = "zh_tw";
      this.local = "zh_tw";
    }
  },
  updated: function () {
  },
  methods: {
    loadList: function (page) {
      var that = this;
      $.ajax({
        url:
          this.$store.state.src +
          this.$store.state.subDirectory +
          "/Html/OrderList",
        type: "post",
        data: {
          Type: that.Type,
          page: page,
          perPage: that.perPage,
          token: $cookies.get("dormitory_login_token"),
        },
        dataType: "json",
        error: function () { },
        success: function (res) {
          if (res.status == 1) {
            that.Orders = res.Orders;
            that.perPage = res.perPage;
            that.pageAll = Math.max(Math.ceil(res.total / that.perPage), 1);
            document.body.scrollTop = 0;
          }
        },
      });
    },
    convertDatetimeString(time, format) {
      var date = new Date(
        time.replace(
          /^(\d{4})(\d\d)(\d\d)(\d\d)(\d\d)(\d\d)$/,
          "$4:$5:$6 $2/$3/$1"
        )
      );
      return moment(date).format(format);
    },
    numberToCurrencyNo(value) {
      if (!value) return 0
      const intPart = Math.trunc(value)
      const intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
      let floatPart = ''
      const valueArray = value.toString().split('.')
      if (valueArray.length === 2) {
        floatPart = valueArray[1].toString()
        return intPartFormat + '.' + floatPart
      }
      return intPartFormat + floatPart
    },
    downloadBill(OrderId) {
      window.open(this.$store.state.src +
        this.$store.state.subDirectory +
        "/Html/OrderBill?OrderId=" + encodeURIComponent(OrderId) + "&token=" + encodeURIComponent($cookies.get("dormitory_login_token")
        ));
    },
  },
};
</script>
